export enum API_URLS {
    CARTS = 'carts',
    ANON_CART = 'anonymousCarts',
    USER = 'user',
    ANON_COUNT = 'anonymousCarts/entries/count',
    COUNT = 'carts/entries/count',
    ALTERNATE_LANGUAGES = 'alternate-languages',
}

export const API_BASE_PATH = 'occ/';
export const CART_TYPE = 'WEBSHOP';

export enum Status {
    IDLE = 'IDLE',
    RUNNING = 'RUNNING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

export enum RequestScope {
    BASIC = 'BASIC',
    DEFAULT = 'DEFAULT',
    FULL = 'FULL',
}
